
function addPickup(fullAddress){
    addPlace('pickup',fullAddress); 
}
function getPickupList(){
  return getPlacesList('pickup')
}
function getPickupListFiltered(fullAddress){
let newList =  getPlacesList('pickup')
newList = newList.filter(item=> item.placeId !== fullAddress.placeId)
return newList; 
}
function removePickup(address){
removePlace('pickup',address)
}

/*************************************************************/

function addAddress(fullAddress){
        addPlace('listPlaces',fullAddress); 
}
function getAddressList(){
      return getPlacesList('listPlaces')
}
function getAddressListFiltered(fullAddress){
    let newList =  getPlacesList('listPlaces')
    newList = newList.filter(item=> item.placeId !== fullAddress.placeId)
    return newList; 
}
function removeAddress(address){
    removePlace('listPlaces',address)
}
/*************************************************************/

function addPlace(key,address){
    let jsonPlaces = localStorage.getItem(key); 
    let listPlaces = JSON.parse(jsonPlaces);   
    if (!listPlaces){
        listPlaces=[]
    }

    const index = listPlaces.findIndex(element=>
         (element.placeId===address.placeId || element.address===address.address)
         )
    if(index<0){
        let timestamp = new Date().getTime();
        address.timestamp = timestamp; 
        listPlaces.push(address)
    }else{
        listPlaces[index] = address
    } 
    listPlaces.sort((a,b)=>b.timestamp-a.timestamp);
    jsonPlaces = JSON.stringify(listPlaces)
    localStorage.setItem(key,jsonPlaces)
}

function getPlacesList(key) {
    let jsonPlaces = localStorage.getItem(key);
    let listPlaces= JSON.parse(jsonPlaces);
    if(!listPlaces){
        listPlaces=[]; 
    }
    listPlaces.sort((a,b)=>b.timestamp-a.timestamp);
    return listPlaces;
}

function removePlace(key,address){
    let jsonPlaces = localStorage.getItem(key); 
    let listPlaces = JSON.parse(jsonPlaces);   
    if (!listPlaces){
        listPlaces=[]
    }
    listPlaces = listPlaces.filter(element=> (element.placeId!=address.placeId))
    jsonPlaces = JSON.stringify(listPlaces)
    localStorage.setItem(key,jsonPlaces)
}


const addressDatasource = {
    add: addAddress,
    list: getAddressList,
    remove: removeAddress,
    listFiltered:getAddressListFiltered
  }; 

const pickupDatasource = {
    add: addPickup,
    list: getPickupList,
    remove: removePickup, 
    listFiltered:getPickupListFiltered
}; 


export {
    addressDatasource,
    pickupDatasource
}

